import { CircularProgress, Fab, FabProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { createRef, useEffect, useState } from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'LoadingFab' })(theme => ({
	root: {
		position: 'relative'
	},
	spinner: {
		position: 'absolute'
	}
}));

export type LoadingFabProps = {
	loading: boolean;
	classes: Partial<ReturnType<typeof useStyles>['classes']>;
} & Omit<FabProps, 'ref' | 'classes'>;

export const LoadingFab: React.FC<LoadingFabProps> = (props) => {
	const { loading, href, children, disabled, classes, className, ...other } = props;
	const theme = useTheme();
	const fabRef = createRef<HTMLButtonElement>();
	const [fabSize, setFabSize] = useState(0);
	let { classes: styles, cx } = useStyles(undefined, { props });

	const progressThickness = (theme.components?.MuiCircularProgress?.defaultProps?.thickness ?? 3.6);
	const progressSize = (theme.components?.MuiCircularProgress?.defaultProps?.size as number ?? 40);
	const fixedThickness = progressThickness * (progressSize / fabSize);

	useEffect(() => {
		if (fabRef.current)
			setFabSize(fabRef.current.getBoundingClientRect().width);
	}, [fabRef]);

	return (
		<Fab
			{...other}
			ref={fabRef}
			className={cx(className, styles.root)}
			disabled={loading || disabled}>
			{children}
			{loading &&
				<CircularProgress
					thickness={fixedThickness}
					size={fabSize}
					className={styles.spinner} />}
		</Fab>
	);
};
